<div class="tw-w-full tw-clear-both tw-text-center tw-pt-4">
    <img src="assets/images/img_offline.svg" alt="Offline image">
</div>
<div *ngIf="offlineDuration" class="tw-mt-8">{{'DIALOG.OFFLINE.TEXT' | translate : { value: offlineDuration } }}</div>
